import { render, staticRenderFns } from "./CbxPolicyType.vue?vue&type=template&id=7c5e571a&"
import script from "./CbxPolicyType.vue?vue&type=script&lang=ts&"
export * from "./CbxPolicyType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports